<template>
  <div class="container MonitorResultView">
    <div> 
    <span class="back" @click="back">  <i class="el-icon-arrow-left"></i> 返回  </span>
    </div>
    <div class="commonWhiteBg">
      <div class="commonTitle"> 
        <!-- 《三体》-网页监测  -->
        网页监测
        <span class="desc"> 总共 <i class="green">{{monitorInfo.total}}</i> 个监测结果 </span>
      </div>
       <ul class="picList">
          <li
            v-for="(item,index) in monitorInfo.list"
            :key="index"
          >
            <div class="listTop">
              <div class="left">监测范围：{{item.platformText}}</div>
              <div class="right">相似度：{{item.obtainResult.similarity}}</div>
            </div>
            <div class="img"> 
              <!-- <img :src="item.items[0].downloadUrl"> -->
              <el-image :src="item.items[0].downloadUrl"
                :preview-src-list="[item.items[0].downloadUrl]" alt="">
              </el-image>
            </div>
            <div class="down">
              <div class="name">名称：{{item.subject}}</div>
              <div class="webSite">链接：{{item.obtainResult.url}} </div>
              <div class="btnWrap">
                <!-- <router-link :to="{path:'/ObtainEvidence/InputForm'}"></router-link> -->
                <!-- <el-button type="primary"> 取证 </el-button> -->
                <el-button type="primary" size="mini" @click="openViewer">查看快照</el-button>
                <el-image-viewer
                  v-if="isOpenViewer"
                  :on-close="closeViewer"
                  :url-list="[item.items[0].downloadUrl,item.items[0].downloadUrl]"
                />
                <el-button type="primary" size="mini"><a :href="item.obtainResult.url" target="_blank">打开链接</a></el-button>
                <el-button type="primary" size="mini" @click="toObtainEvidence(item.orderNo)">一键取证</el-button>
              </div>
            </div>
          </li>
        </ul>


        <!-- <el-table :data="monitorInfo.list" style="width: 100%">
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <div class="title">
                <span class="name">{{ scope.row.subject }} </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="监测范围">
            <template slot-scope="scope">
              <div class="logoRow">
                <span class="name">{{ scope.row.platformText }} </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="num1" label="相似度">
            <template slot-scope="scope">
              <div class="bigNum">{{ scope.row.obtainResult.similarity }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num2" label="监测数量">
            <template slot-scope="scope">
              <div class="bigNum">
                <el-button type="primary" size="mini" @click="openViewer">查看快照</el-button>
                <el-image-viewer
                  v-if="isOpenViewer"
                  :on-close="closeViewer"
                  :url-list="[scope.row.items[0].downloadUrl,scope.row.items[0].downloadUrl]"
                />
                <el-button type="primary" size="mini"><a :href="scope.row.obtainResult.url" target="_blank">打开链接</a></el-button>
                <el-button type="primary" size="mini" @click="toObtainEvidence(scope.row.orderNo)">一键取证</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table> -->

        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          :current-page.sync="pagination.page"
          :page-size.sync="pagination.pageSize"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>

    </div>

  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import constants from "@/utils/constants";
import { queryMonitor,goObtain } from "@/api/EvidenceService";

export default {
  name: 'MonitorResult',
  components: { ElImageViewer },
  data () {
    return {
      constants,
      isOpenViewer: false,
      picList: [
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result1.png',
        //   name: '三体-刘慈欣-在线阅读',
        //   webSite: 'http://www.shizongzui.cc/santi/'
        // },
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result2.png',
        //   name: '三体-刘慈欣-在线阅读',
        //   webSite: 'https://www.kunnu.com/santi/'
        // },
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result3.png',
        //   name: '三体-最新章节-免费阅读',
        //   webSite: 'https://www.znlzd.com/bqg/1403/'
        // }
      ],
      tableData: [
        // {
        //   name: "百度",
        //   num1: "0",
        //   num2: "0",
        //   logo: "https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/baidu.png",
        // },
        // {
        //   title: '11111',
        //   name: '百度',
        //   resemble: '80%',
        //   num2: '1',
        // },
        // {
        //   title: '22222',
        //   name: '腾讯',
        //   resemble: '40%',
        //   num2: '5',
        // },
      ],
      monitorInfo: {},
      pagination: {
        page: 1,
        pageSize: 9,
        total:0
      },
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(){
        this.orderId = this.$route.query.orderId;
        // 获取检测结果详情列表
        queryMonitor(this.pagination.page,this.pagination.pageSize,this.orderId).then(({data})=>{
          console.log('获取检测结果:',data);
          this.monitorInfo = data;
          for(let i in this.monitorInfo.list){
            this.monitorInfo.list[i].platformText = this.constants.platform[this.monitorInfo.list[i].platformId].label;
          }
          this.pagination.total=data.total*1;
        })
    },



     back(){
        this.$router.go(-1);//返回上一层
    },
     onSeePdf(item){
      this.$router.push({
            path: "/ExistingEvidence/PdfView",
            query: {}
          });
    },
    onDownLoad(item){

    },

    // 查看快照
    openViewer() {
      this.isOpenViewer = true
    },
    // 关闭图片预览
    closeViewer() {
      this.isOpenViewer = false
    },

    // 一键取证
    toObtainEvidence(orderNo){
        // console.log(orderNo);
        goObtain(orderNo).then(({data})=>{
          // console.log('一键取证:',data);
        })
    },



    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },
  }
}
</script>

<style lang='scss' scoped>
    @import '../../../assets/css/inputForm.scss';
    .el-button+.el-button{margin-left: 5px;}
    .el-button + .el-button a{color: #fff;border: none;text-decoration: none;}
    .commonWhiteBg .el-pagination{margin-top: 16px;}

    .picList li{margin-bottom: 20px;box-shadow: 0 0 16px rgba(0, 109, 117, 0.1);border-radius: 5px;}
    .picList > li:nth-child(3n+2){margin-bottom: 20px;}
    .picList .listTop{height: 40px;padding: 0 16px;line-height: 40px;}
    .picList .listTop .left{float: left;}
    .picList .listTop .right{float: right;}
    .picList li .name,.picList li .webSite{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 0;}
    .picList .btnWrap{display: flex;justify-content: space-between;align-items: center;}
</style>
